import { useEffect, useState } from "react";
import { MapPinned } from "lucide-react";
import { useNavigate } from "react-router-dom";
import API from "../api/api";
import AdminLayout from "../layouts/AdminLayout";
import "./Tours.css";
import "./Tours-title-ellipsis.css";

const TOURS_FILTER_STORAGE_KEY = "tours_filters";

export default function Tours() {

    const defaultTourFilters = {
    selectedTour: "all",
    filter: "upcoming",
    dateFilter: "",
    cardsPerRow: "3",
    page: 1,
    onlyBooked: true,
    languageFilter: "all"
};

const navigate = useNavigate();

const [tours,setTours]=useState([]);

const [sessions,setSessions]=useState([]);
const [coordinators, setCoordinators] = useState([]);
const [guides, setGuides] = useState([]);

const [total, setTotal] =
    useState(0);

    const languages = [
    ...new Set(
        sessions
            .map(s => s.languages)
            .filter(Boolean)
            .flatMap(lang =>
                lang
                    .split(",")
                    .map(l => l.trim())
                    .filter(Boolean)
            )
    )
].sort();

const savedTourFilters =
    JSON.parse(
        localStorage.getItem(
            TOURS_FILTER_STORAGE_KEY
        ) || "null"
    ) || defaultTourFilters;

    const [selectedTour, setSelectedTour] =
    useState(savedTourFilters.selectedTour);

const [filter, setFilter] =
    useState(savedTourFilters.filter);

const [dateFilter, setDateFilter] =
    useState(savedTourFilters.dateFilter);

const [cardsPerRow, setCardsPerRow] =
    useState(savedTourFilters.cardsPerRow);

const limit = 100;

const [currentPage, setCurrentPage] = useState(1);

const [onlyBooked, setOnlyBooked] =
    useState(savedTourFilters.onlyBooked);

const [onlyGuideAssigned, setOnlyGuideAssigned] =
    useState(savedTourFilters.onlyGuideAssigned ?? false);

const [onlyTicketsUploaded, setOnlyTicketsUploaded] =
    useState(savedTourFilters.onlyTicketsUploaded ?? false);

const [languageFilter, setLanguageFilter] =
    useState(savedTourFilters.languageFilter);

    useEffect(() => {

    localStorage.setItem(
        TOURS_FILTER_STORAGE_KEY,
        JSON.stringify({
    selectedTour,
    filter,
    dateFilter,
    cardsPerRow,
    limit,
    onlyBooked,
    onlyGuideAssigned,
    onlyTicketsUploaded,
    languageFilter
})
    );

}, [
    selectedTour,
filter,
dateFilter,
cardsPerRow,
limit,
onlyBooked,
onlyGuideAssigned,
onlyTicketsUploaded,
languageFilter
]);

useEffect(()=>{

API.get("/tours")
.then(res=>setTours(res.data || []));

API.get("/admin/coordinators")
.then(res => setCoordinators(res.data || []))
.catch(err => {
    console.error("Unable to load coordinators:", err);
});

API.get("/admin/guides")
.then(res => setGuides(Array.isArray(res.data) ? res.data : []))
.catch(err => {
    console.error("Unable to load guides:", err);
});

API.get(
    `/tour-sessions?page=${currentPage}&limit=${limit}` +
    `&filter=${filter}` +
    `&selectedTour=${selectedTour}` +
    `&dateFilter=${dateFilter}` +
    `&onlyBooked=${onlyBooked}` +
    `&onlyGuideAssigned=${onlyGuideAssigned}` +
    `&onlyTicketsUploaded=${onlyTicketsUploaded}` +
    `&languageFilter=${languageFilter}`
)

.then(res => {
console.log(res.data.rows[0]);
    console.log(
        "SUCCESS",
        res.data
    );

    setSessions(
        res.data.rows || []
    );

    setTotal(
        res.data.total
    );

})
.catch(err => {

    console.error(
        "API ERROR",
        err.response?.status,
        err.response?.data,
        err.message
    );

});


}, [
    currentPage,
    filter,
    selectedTour,
    dateFilter,
    onlyBooked,
    onlyGuideAssigned,
    onlyTicketsUploaded,
    languageFilter
]);



useEffect(() => {
    setCurrentPage(1);
}, [
    filter,
    selectedTour,
    dateFilter,
    onlyBooked,
    onlyGuideAssigned,
    onlyTicketsUploaded,
    languageFilter
]);




/* ================= FORMAT ================= */

const formatDate = (dateString) => {
    if (!dateString) return "-";

    return new Date(dateString).toLocaleDateString(
        "en-GB",
        {
            weekday: "long",
            day: "2-digit",
            month: "long",
            year: "numeric"
        }
    );
};

const formatTime = (dateString) => {
    if (!dateString) return "-";

    return new Date(dateString).toLocaleTimeString(
        "en-GB",
        {
            hour: "2-digit",
            minute: "2-digit",
            hour12: false
        }
    );
};


const dateRow = {
    margin: "0 0 2px 0",
    fontSize: 13,
    color: "#111827",
    fontWeight: 700
};

const timeRow = {
    margin: "0 0 8px 0",
    fontSize: 13,
    color: "#111827",
    fontWeight: 700
};


/* ================= STATUS ================= */


const getStatus=(s)=>{


const now=new Date();

const end=new Date(
s.end_datetime
);



if(end<now)

return {
label:"Past",
color:"#64748b"
};



if(s.fill_percent>=100)

return {
label:"Full",
color:"#ef4444"
};



if(s.fill_percent>=80)

return {
label:"Nearly Full",
color:"#f59e0b"
};



return {

label:"Open",

color:"#22c55e"

};


};


/* ================= FILTER ================= */


const filteredSessions = sessions

.filter(s => {

const now = new Date();

const end = new Date(
s.end_datetime
);


const matchesTour =
selectedTour==="all"
||
s.tour_id===Number(selectedTour);



const matchesTime =

filter==="upcoming"

?

end >= now

:

filter==="past"

?

end < now

:

true;



const matchesDate =

dateFilter === ""

?

true

:

s.start_datetime.startsWith(dateFilter);

const matchesBooked =
    !onlyBooked ||
    s.booked > 0;

const matchesGuide =
    !onlyGuideAssigned ||
    (s.guide_first_name && s.guide_last_name);

const matchesTickets =
    !onlyTicketsUploaded ||
    Boolean(s.has_ticket);

const matchesLanguage =
    languageFilter === "all" ||
    (s.languages || "")
        .split(",")
        .map(l => l.trim())
        .includes(languageFilter);


return (
    matchesTour &&
    matchesTime &&
    matchesDate &&
    matchesBooked &&
    matchesGuide &&
    matchesTickets &&
    matchesLanguage
);

});

const assignGuide = async (sessionId, guideId) => {
    if (!guideId) return;

    const session = sessions.find(s => s.id === sessionId);
    if (!session) return;

    // The existing backend only assigns to unassigned sessions.
    // Require an explicit unassign before switching an existing guide.
    if (
        session.guide_id ||
        (session.guide_first_name && session.guide_last_name)
    ) {
        alert("Please unassign the current guide before selecting another guide.");
        return;
    }

    try {
        await API.post("/admin/guides/assign", {
            guideId: Number(guideId),
            sessionId
        });

        const selectedGuide = guides.find(
            g => Number(g.id) === Number(guideId)
        );

        setSessions(prev =>
            prev.map(s =>
                s.id === sessionId
                    ? {
                        ...s,
                        guide_id: Number(guideId),
                        guide_first_name: selectedGuide?.first_name || "",
                        guide_last_name: selectedGuide?.last_name || ""
                    }
                    : s
            )
        );
    } catch (err) {
        console.error("assignGuide error:", err);
        alert(
            err.response?.data?.error ||
            "Unable to assign guide"
        );
    }
};

const unassignGuide = async (sessionId) => {
    try {
        await API.post("/admin/guides/unassign", { sessionId });

        setSessions(prev =>
            prev.map(s =>
                s.id === sessionId
                    ? {
                        ...s,
                        guide_id: null,
                        guide_first_name: null,
                        guide_last_name: null
                    }
                    : s
            )
        );
    } catch (err) {
        console.error("unassignGuide error:", err);
        alert(
            err.response?.data?.error ||
            "Unable to unassign guide"
        );
    }
};


const assignCoordinator = async (
    sessionId,
    coordinatorId
) => {

    if (!coordinatorId) return;

    try {

        await API.post(
            "/admin/coordinators/assign",
            {
                coordinatorId,
                sessionId
            }
        );

        setSessions(prev =>
            prev.map(s =>
                s.id === sessionId
                    ? {
                        ...s,

                        coordinator_id:
                            Number(coordinatorId),

                        coordinator_first_name:
                            coordinators.find(
                                c =>
                                    Number(c.id) ===
                                    Number(coordinatorId)
                            )?.first_name || "",

                        coordinator_last_name:
                            coordinators.find(
                                c =>
                                    Number(c.id) ===
                                    Number(coordinatorId)
                            )?.last_name || ""
                    }
                    : s
            )
        );

    } catch (err) {

        console.error(
            "assignCoordinator error:",
            err
        );

        alert(
            err.response?.data?.error ||
            "Unable to assign coordinator"
        );

    }

};


const unassignCoordinator = async (
    sessionId
) => {

    try {

        await API.post(
            "/admin/coordinators/unassign",
            {
                sessionId
            }
        );

        setSessions(prev =>
            prev.map(s =>
                s.id === sessionId
                    ? {
                        ...s,

                        coordinator_id: null,

                        coordinator_first_name:
                            null,

                        coordinator_last_name:
                            null
                    }
                    : s
            )
        );

    } catch (err) {

        console.error(
            "unassignCoordinator error:",
            err
        );

        alert(
            err.response?.data?.error ||
            "Unable to unassign coordinator"
        );

    }

};


return (
  <AdminLayout>
    <div className="tours-page">

      <div className="tours-breadcrumb">
         <span>›</span> Tours
      </div>

      <div className="tours-page-header">
        <div>
          <h1 className="tours-title">
            Tours
            <span className="tours-count">{total}</span>
          </h1>
          <p className="tours-subtitle">
            Manage upcoming tours, capacity, guides and tickets.
          </p>
        </div>
      </div>

      <section className="tours-filter-card">
        <div className="tours-filter-grid">

          <div className="tours-field">
            <label>Date</label>
            <input
              type="date"
              value={dateFilter}
              onChange={(e) => setDateFilter(e.target.value)}
            />
          </div>

          <div className="tours-field">
            <label>Tour</label>
            <select
              value={selectedTour}
              onChange={(e) => setSelectedTour(e.target.value)}
            >
              <option value="all">All Tours</option>
              {tours.map(t => (
                <option key={t.id} value={t.id}>
                  {t.title}
                </option>
              ))}
            </select>
          </div>

          <div className="tours-field">
            <label>Language</label>
            <select
              value={languageFilter}
              onChange={(e) => setLanguageFilter(e.target.value)}
            >
              <option value="all">All Languages</option>
              {languages.map(lang => (
                <option key={lang} value={lang}>
                  {lang}
                </option>
              ))}
            </select>
          </div>

          <div className="tours-field">
            <label>View</label>
            <select
              value={cardsPerRow}
              onChange={(e) => setCardsPerRow(e.target.value)}
            >
              <option value="2">2 cards / row</option>
              <option value="3">3 cards / row</option>
              <option value="4">4 cards / row</option>
            </select>
          </div>

          <div className="tours-field">
            <label>Period</label>
            <select
              value={filter}
              onChange={(e) => setFilter(e.target.value)}
            >
              <option value="upcoming">Upcoming</option>
              <option value="past">Past</option>
              <option value="all">All</option>
            </select>
          </div>

        </div>

        <div className="tours-filter-footer">
          <div className="tours-checks">
            <label className="tours-check">
              <input
                type="checkbox"
                checked={onlyBooked}
                onChange={(e) => setOnlyBooked(e.target.checked)}
              />
              <span>Only booked</span>
            </label>

            <label className="tours-check">
              <input
                type="checkbox"
                checked={onlyGuideAssigned}
                onChange={(e) => setOnlyGuideAssigned(e.target.checked)}
              />
              <span>Guide assigned</span>
            </label>

            <label className="tours-check">
              <input
                type="checkbox"
                checked={onlyTicketsUploaded}
                onChange={(e) => setOnlyTicketsUploaded(e.target.checked)}
              />
              <span>Tickets uploaded</span>
            </label>
          </div>

          <div className="tours-result-count">
            Showing <strong>{sessions.length}</strong> of <strong>{total}</strong> sessions
          </div>
        </div>
      </section>

      <div
        className="tours-grid"
        style={{
          gridTemplateColumns: `repeat(${cardsPerRow}, minmax(0, 1fr))`
        }}
      >
        {filteredSessions.length === 0 ? (
          <div className="tours-empty">
            <MapPinned size={30} />
            <strong>No tours found</strong>
            <span>Try changing the filters above.</span>
          </div>
        ) : (
          filteredSessions.map(s => {
            const status = getStatus(s);

            const hasGuide =
              s.guide_first_name &&
              s.guide_last_name;

            const guide = hasGuide
              ? `${s.guide_first_name} ${s.guide_last_name}`
              : "No guide assigned";

            const assignedGuideId =
              s.guide_id ||
              guides.find(g =>
                g.first_name === s.guide_first_name &&
                g.last_name === s.guide_last_name
              )?.id ||
              "";

            const hasCoordinator =
              s.coordinator_first_name &&
              s.coordinator_last_name;

            const coordinator = hasCoordinator
              ? `${s.coordinator_first_name} ${s.coordinator_last_name}`
              : "Unassigned";

            return (
              <article className="tour-card" key={s.id}>

                <div className="tour-card-top">
                  <div className="tour-card-title-wrap">
                    <h2>{s.tour_name}</h2>
                    <span
                      className="tour-status"
                      style={{
                        color: status.color,
                        background: `${status.color}16`,
                        borderColor: `${status.color}35`
                      }}
                    >
                      {status.label}
                    </span>
                  </div>
                </div>

                <div className="tour-meta-block">
                  <div className="tour-meta-row">
                    <span className="tour-meta-icon">📅</span>
                    <div>
                      <small>Date</small>
                      <strong>{formatDate(s.start_datetime)}</strong>
                    </div>
                  </div>

                  <div className="tour-meta-row">
                    <span className="tour-meta-icon">◷</span>
                    <div>
                      <small>Time</small>
                      <strong>
                        {formatTime(s.start_datetime)} — {formatTime(s.end_datetime)}
                      </strong>
                    </div>
                  </div>

                  <div className="tour-capacity-row">
                    <div>
                      <small>Guests</small>
                      <strong>{s.booked}/{s.capacity}</strong>
                    </div>
                    <span>{s.fill_percent}% filled</span>
                  </div>

                  <div className="tour-progress">
                    <div
                      style={{
                        width: `${Math.min(Number(s.fill_percent) || 0, 100)}%`,
                        background: status.color
                      }}
                    />
                  </div>
                </div>

                <div className="tour-details-list">
                  <div className="tour-detail-line">
                    <span>Guide</span>
                    <strong className={hasGuide ? "is-ok" : "is-missing"}>
                      {hasGuide ? "✓ " : "× "}{guide}
                    </strong>
                  </div>

                  <div className="tour-detail-line">
                    <span>Coordinator</span>
                    <strong className={hasCoordinator ? "is-ok" : "is-missing"}>
                      {coordinator}
                    </strong>
                  </div>

                  <div className="tour-detail-line">
                    <span>Tickets</span>
                    <strong className={s.has_ticket ? "is-ok" : "is-ticket-missing"}>
                      {s.has_ticket ? "Uploaded" : "Not uploaded"}
                    </strong>
                  </div>
                </div>

                {s.languages && (
                  <div className="tour-languages">
                    {s.languages.split(",").map(lang => (
                      <span key={lang.trim()}>{lang.trim()}</span>
                    ))}
                  </div>
                )}

                <div className="tour-assignment">
                  <div className="tour-assignment-group">
                    <label>Guide</label>
                    <div className="tour-assignment-row">
                      <select
                        value={assignedGuideId}
                        onChange={(e) =>
                          assignGuide(s.id, e.target.value)
                        }
                      >
                        <option value="">Select guide</option>
                        {guides.map(g => (
                          <option
                            key={g.id}
                            value={g.id}
                            disabled={
                              Boolean(assignedGuideId) &&
                              Number(assignedGuideId) !== Number(g.id)
                            }
                          >
                            {g.first_name} {g.last_name}
                          </option>
                        ))}
                      </select>

                      {hasGuide && (
                        <button
                          type="button"
                          onClick={() => unassignGuide(s.id)}
                        >
                          Unassign
                        </button>
                      )}
                    </div>
                  </div>

                  <div className="tour-assignment-group">
                    <label>Coordinator</label>
                    <div className="tour-assignment-row">
                      <select
                        value={s.coordinator_id || ""}
                        onChange={(e) =>
                          assignCoordinator(s.id, e.target.value)
                        }
                      >
                        <option value="">Select coordinator</option>
                        {coordinators.map(c => (
                          <option key={c.id} value={c.id}>
                            {c.first_name} {c.last_name}
                          </option>
                        ))}
                      </select>

                      {hasCoordinator && (
                        <button
                          type="button"
                          onClick={() => unassignCoordinator(s.id)}
                        >
                          Unassign
                        </button>
                      )}
                    </div>
                  </div>
                </div>

                <div className="tour-card-footer">
                  <span>{s.fill_percent}% filled</span>
                  <button
                    type="button"
                    onClick={() => navigate(`/admin/tour/${s.id}`)}
                  >
                    View details <span>→</span>
                  </button>
                </div>

              </article>
            );
          })
        )}
      </div>

      {total > limit && (
        <div className="tours-pagination">
          <div className="tours-pagination-summary">
            Showing <strong>{(currentPage - 1) * limit + 1}</strong> – <strong>{Math.min(currentPage * limit, total)}</strong> of <strong>{total}</strong>
          </div>

          <div className="tours-pagination-controls">
            <button
              onClick={() => setCurrentPage(p => Math.max(1, p - 1))}
              disabled={currentPage === 1}
            >
              Previous
            </button>

            <span>Page {currentPage} of {Math.ceil(total / limit)}</span>

            <button
              onClick={() =>
                setCurrentPage(p =>
                  p < Math.ceil(total / limit) ? p + 1 : p
                )
              }
              disabled={currentPage >= Math.ceil(total / limit)}
            >
              Next
            </button>
          </div>
        </div>
      )}

    </div>
  </AdminLayout>
);
}